// extracted by mini-css-extract-plugin
var _1 = "#222222";
var _2 = "#f4f2f1";
export { _1 as "darkFallbackColor", _2 as "defaultFallbackColor" }
